"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import "../css/admin.css"
import { IoClose } from "react-icons/io5"
import { useToast } from "../components/ToastProvider"
import { IoChevronDown, IoChevronUp } from "react-icons/io5"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const Admin = () => {
  const navigate = useNavigate()
  const [adminData, setAdminData] = useState(null)

  // 카테고리 상태
  const [categories, setCategories] = useState([])
  const [newCategory, setNewCategory] = useState("")
  const [d, sd] = useState("")
  const showToast = useToast()

  // 말머리 상태
  const [headings, setHeadings] = useState([])
  const [forms, setForms] = useState([])
  const [newHeading, setNewHeading] = useState("")
  const [headingColor, setHeadingColor] = useState("#000000") // 기본 검정색

  const [newDeco, setNewDeco] = useState("")
  const [decoColor, setDecoColor] = useState("#000000") // 기본 검정색
  const [key, setKey] = useState(0)

  const [slogan, setSlogan] = useState("")
  const [newAdmin, setNewAdmin] = useState("")
  const [experts, setExperts] = useState([])
  const [admins, setAdmins] = useState([])
  const [monthly, setMonthly] = useState([])

  const [userCategory, setUserCategory] = useState([])
  const [userCompany, setUserCompany] = useState([])
  const [nletter, setNletter] = useState([])
  const [newUserCategory, setNewUserCategory] = useState("")
  const [newUserCompany, setNewUserCompany] = useState("")

  const [articleTransfer, setArticleTransfer] = useState(null)
  const [targetCategory, setTargetCategory] = useState(null)

  const [editedDesc, setEditedDesc] = useState(null)


  
  const [expertEmail, setExpertEmail] = useState(null)
  const [expertComment, setExpertComment] = useState(null)

  const [logoFile, setLogoFile] = useState(null);

  // 섹션 접기/펼치기 상태 관리
  const [expandedSections, setExpandedSections] = useState({
    userCategory: false,
    userCompany: false,
    category: false,
    heading: false,
    slogan: false,
    monthly: false,
    forms: false,
    admin: false,
    expert: false,
    newsletter: false,
    logoImage: false,
  })

  // 섹션 토글 함수
  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section],
    })
  }

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const token = localStorage.getItem("token")
        if (!token) {
          showToast("로그인 후 사용할 수 있는 기능입니다.", { type: "warn" })
          navigate("/")
          return
        }

        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin`, {
          token: token,
        })
        setAdminData(data.admin)
        setCategories(data.category)
        setHeadings(data.head)
        setNletter(data.newsletter)
        setUserCategory(data.userCategory)
        setUserCompany(data.userCompany)
        sd(data)
      } catch (error) {
        alert("어드민 권한이 없습니다.")
        navigate("/")
      }
    }
    const fetchSlogan = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/slogan`, {})
        console.log(data)
        setSlogan(data.slogan)
      } catch (error) {}
    }
    const fetchForm = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/form/fetch`, {})
        setForms(data.forms)
        console.log("zz", data)
      } catch (error) {}
    }
    const fetchAdmin = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/fetch`, {})
        setAdmins(data.admins);
        setExperts(data.expert)
      } catch (error) {}
    }
    const fetchMonthly = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/monthly`, {})
        console.log(data)
        setMonthly(data.results)
      } catch (error) {
        alert("e")
      }
    }

    fetchMonthly()
    fetchAdmin()
    fetchForm()
    fetchSlogan()
    fetchAdminData()
  }, [navigate])

  const addCategory = async () => {
    if (!newDeco) return alert("카테고리명을 입력하세요.")

    try {
      const token = localStorage.getItem("token")
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/add`, {
        name: newDeco,
        color: decoColor,
        token: token,
        type: "category",
      })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteDeco = async (id) => {
    try {
      const token = localStorage.getItem("token")
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/delete`, { id: id })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  // 말머리 추가
  const addHead = async () => {
    if (!newDeco) return alert("말머리명을 입력하세요.")

    try {
      const token = localStorage.getItem("token")
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/add`, {
        name: newDeco,
        color: decoColor,
        token: token,
        type: "head",
      })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const updateSlogan = async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/slogan/update`, { slogan: slogan })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteForm = async (key) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/form/delete`, { key })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteAdmin = async (email) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/deleteadmin`, { email })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteMonthly = async (id) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/deletemonthly`, { id })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const addAdmin = async () => {
    const email = newAdmin
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/addadmin`,
        { email }, // Make sure the property name matches what the server expects
      )
      console.log("Success:", response.data)
      window.location.reload()
    } catch (error) {
      console.error("Error adding admin:", error.message)
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const addUserCategory = async () => {
    if (!newUserCategory) return alert("말머리명을 입력하세요.")
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/addusercategory`, { name: newUserCategory })
      setUserCategory(data.category)
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const addUserCompany = async () => {
    if (!newUserCompany) return alert("말머리명을 입력하세요.")
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/addusercompany`, { name: newUserCompany })
      setUserCompany(data.company)
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteUserCompany = async (target) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/deleteusercompany`, { target })
      setUserCompany(data.company)
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const deleteUserCategory = async (target) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/deleteusercategory`, { target })
      setUserCategory(data.category)
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const toggleTransfer = (targetCategory2) => {
    setTargetCategory(targetCategory2)

    const transferPopup = document.getElementById("transfer-popup")
    if (transferPopup.style.display === "none" || transferPopup.style.display === "") {
      transferPopup.style.display = "block" // Change this to 'flex' if needed;
    } else {
      transferPopup.style.display = "none"
    }
  }

  const deleteCategory = async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category_delete`, { targetCategory, articleTransfer })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "삭제하려는 카테고리와 다른 카테고리를 선택하세요.")
    }
  }

  const updateCategory = async (code) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/category/update`, { code, desc: editedDesc })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  
  const addExpert = async () => {
    const email = expertEmail;
    const category = expertComment;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/addexpert`,
        { email, category }, // Make sure the property name matches what the server expects
      )
      console.log("Success:", response.data)
      window.location.reload()
    } catch (error) {
      console.error("Error adding admin:", error.message)
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }
  const deleteExpert = async (email) => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/deleteexpert`, { email })
      window.location.reload()
    } catch (error) {
      alert(error.response?.data?.message || "오류가 발생했습니다.")
    }
  }

  const handleLogoFileChange = (e) => {
    setLogoFile(e.target.files[0]);
  };

  const uploadLogoImage = () => {
    if (!logoFile) {
      alert("파일을 선택해주세요.");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onloadend = async () => {
      const base64String = reader.result; // 전체 Data URL 형식
  
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/logo/update`,
          { image: base64String }
        ); 
        window.location.reload()
      } catch (error) {
        console.error("업로드 실패", error);
        alert("업로드 실패");
      }
    };
  
    reader.readAsDataURL(logoFile);
  };
  



  const restrictedIds = ["NOT", "DIS", "EVE", "NEWS", "Q"] // 삭제를 막을 ID 리스트
  if (!adminData) return <p>로딩 중...</p>

  const sectionHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    padding: "10px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    marginBottom: "10px",
  }

  // 섹션 콘텐츠 스타일
  const sectionContentStyle = {
    padding: "10px",
    border: "1px solid #eee",
    borderRadius: "4px",
    marginBottom: "15px",
  }

  const exportToExcel = () => {
    console.log(nletter)
    const filename = 'newsletter.xlsx'; 
    const worksheet = XLSX.utils.json_to_sheet(nletter);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    saveAs(data, filename);
  };

  return (
    <>
      <div className="pf-popup" id="transfer-popup" style={{ display: "none" }}>
        <IoClose onClick={toggleTransfer} />
        <h2>카테고리 삭제하기</h2>
        <span>해당 카테고리가 삭제된 후, 해당 카테고리의 글을 이동할 카테고리를 선택해주세요.</span>
        <select value={articleTransfer} onChange={(e) => setArticleTransfer(e.target.value)}>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
        <div className="pf-lct">
          <button onClick={deleteCategory}>카테고리 삭제</button>
        </div>
      </div>

      <div className="admin-container">
        <h2>어드민 대시보드</h2>
        <p>환영합니다</p>

        <div className="ad-flex-2">
          <div className="ad-ct">
            {/* 유저 분야 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("userCategory")}>
                <h3>유저 분야 관리</h3>
                {expandedSections.userCategory ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.userCategory && (
                <div style={sectionContentStyle}>
                  {userCategory.map((ct) => (
                    <li key={ct}>
                      {ct}
                      <button onClick={() => deleteUserCategory(ct)}>삭제하기</button>
                    </li>
                  ))}
                  <input
                    type="text"
                    placeholder="새 유저 분야 입력"
                    value={newUserCategory}
                    onChange={(e) => setNewUserCategory(e.target.value)}
                  />
                  <button onClick={addUserCategory}>추가</button>
                </div>
              )}
            </div>

            {/* 유저 회사 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("userCompany")}>
                <h3>유저 회사 관리</h3>
                {expandedSections.userCompany ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.userCompany && (
                <div style={sectionContentStyle}>
                  {userCompany.map((ct) => (
                    <li key={ct}>
                      {ct}
                      <button onClick={() => deleteUserCompany(ct)}>삭제하기</button>
                    </li>
                  ))}
                  <input
                    type="text"
                    placeholder="새 유저 회사 입력"
                    value={newUserCompany}
                    onChange={(e) => setNewUserCompany(e.target.value)}
                  />
                  <button onClick={addUserCompany}>추가</button>
                </div>
              )}
            </div>

            {/* 카테고리 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("category")}>
                <h3>카테고리 관리</h3>
                {expandedSections.category ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.category && (
                <div style={sectionContentStyle} className="category-section">
                  <input
                    type="text"
                    placeholder="새 카테고리 입력"
                    value={newDeco}
                    onChange={(e) => setNewDeco(e.target.value)}
                  />
                  <input type="color" value={decoColor} onChange={(e) => setDecoColor(e.target.value)} />
                  <button onClick={addCategory}>추가</button>
                  <ul>
                    {categories.map((category) => (
                      <li key={category._id}>
                        {category.name}
                        <input
                          placeholder="카테고리 소개"
                          value={category.desc}
                          onChange={(e) => setEditedDesc(e.target.value)}
                        ></input>
                        <button onClick={() => toggleTransfer(category.id)}>삭제하기</button>
                        <button onClick={() => updateCategory(category.id)}>업데이트</button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* 말머리 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("heading")}>
                <h3>말머리 관리</h3>
                {expandedSections.heading ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.heading && (
                <div style={sectionContentStyle} className="heading-section">
                  <input
                    type="text"
                    placeholder="새 말머리 입력"
                    value={newDeco}
                    onChange={(e) => setNewDeco(e.target.value)}
                  />
                  <input type="color" value={decoColor} onChange={(e) => setDecoColor(e.target.value)} />
                  <button onClick={addHead}>추가</button>

                  <ul>
                    {headings.map((heading) => (
                      <li key={heading._id} style={{ color: heading.color }}>
                        {heading.name}
                        {!restrictedIds.includes(heading.id) && (
                          <button onClick={() => deleteDeco(heading.id)}>삭제하기</button>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* 슬로건 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("slogan")}>
                <h3>슬로건 관리</h3>
                {expandedSections.slogan ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.slogan && (
                <div style={sectionContentStyle} className="heading-section">
                  <input type="text" placeholder="슬로건" value={slogan} onChange={(e) => setSlogan(e.target.value)} />
                  <button onClick={updateSlogan}>수정</button>
                </div>
              )}
            </div>

            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("logoImage")}>
                <h3>로고 이미지 관리</h3>
                {expandedSections.logoImage ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.logoImage && (
                <div style={sectionContentStyle} className="heading-section">
                   <input type="file" accept="image/*" onChange={handleLogoFileChange} />
                   <button onClick={uploadLogoImage}>로고 업로드</button>
                </div>
              )}
            </div>
          </div>

          <div className="ad-ct">
            {/* 월간지 발행 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("monthly")}>
                <h3>월간지 발행 관리</h3>
                {expandedSections.monthly ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.monthly && (
                <div style={sectionContentStyle}>
                  <button onClick={() => (window.location.href = `/monthly/write`)}>월간지 에디터 열기</button>
                  {monthly.map((at) => (
                    <div className="mt-article" key={at.id}>
                      <div className="mt-article-left">
                        <div className="mt-article-title">{at.month}월 월간지</div>
                        <div className="mt-article-desc">{at.title}</div>
                      </div>
                      <div
                        className="mt-article-view"
                        onClick={() => (window.location.href = `/monthly/article/${at.id}`)}
                      >
                        글 확인
                      </div>
                      <div className="mt-article-view" onClick={() => deleteMonthly(at.id)}>
                        삭제하기
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* 문의/신고 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("forms")}>
                <h3>문의 / 신고 관리</h3>
                {expandedSections.forms ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.forms && (
                <div style={sectionContentStyle}>
                  {forms.map((fr) => (
                    <div className="ad-fr" key={fr.key}>
                      식별자: {fr.key} / 응답 원하는 이메일{fr.email}
                      <div className="ad-preview" dangerouslySetInnerHTML={{ __html: fr?.content }}></div>
                      기록 시점: {fr.date}
                      <button onClick={() => deleteForm(fr.key)}>문의/신고 삭제</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="ad-ct">
            {/* 관리자 관리 섹션 */}
            <div className="admin-section">
              <div style={sectionHeaderStyle} onClick={() => toggleSection("admin")}>
                <h3>관리자 관리</h3>
                {expandedSections.admin ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.admin && (
                <div style={sectionContentStyle}>
                  <input
                    placeholder="추가할 관리자 이메일"
                    value={newAdmin}
                    onChange={(e) => setNewAdmin(e.target.value)}
                  />
                  <button onClick={addAdmin}>관리자 추가</button>

                  {admins.map((ad) => (
                    <div className="ad-fr" key={ad.email}>
                      관리자 이메일{ad.email}
                      <button onClick={() => deleteAdmin(ad.email)}>관리자 삭제</button>
                    </div>
                  ))}
                </div>
              )}

              <div style={sectionHeaderStyle} onClick={() => toggleSection("expert")}>
                <h3>익스퍼트 관리</h3>
                {expandedSections.expert ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.expert && (
                <div style={sectionContentStyle}>
                  <input
                    placeholder="추가할 익스퍼트 이메일"
                    value={expertEmail}
                    onChange={(e) => setExpertEmail(e.target.value)}
                  />
                  <input
                    placeholder="추가할 익스퍼트 분야"
                    value={expertComment}
                    onChange={(e) => setExpertComment(e.target.value)}
                  />
                  <button onClick={addExpert}>익스퍼트 추가</button>

                  {experts.map((ad) => (
                    <div className="ad-fr" key={ad.email}>
                      익스퍼트 이메일{ad.email}
                      <button onClick={() => deleteExpert(ad.email)}>익스퍼트 삭제</button>
                    </div>
                  ))}
                </div>
              )}

              <div style={sectionHeaderStyle} onClick={() => toggleSection("newsletter")}>
                <h3>뉴스레터 리스트</h3>
                {expandedSections.newsletter ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
              </div>

              {expandedSections.newsletter && (
                <button onClick={exportToExcel}>뉴스레터 동의 이메일 엑셀 다운로드</button>
              )}
            </div>
          </div>
          
        </div>
      </div>
    </>
  )
}

export default Admin

